const features = [
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式连续阅读',
    desc: '无需翻页，下滑即可持续阅读，沉浸式追漫体验，告别频繁点击翻页的烦恼。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载不卡顿',
    desc: '全球CDN加速，漫画图片秒加载，高清画质下依然保持流畅阅读，看漫零等待。',
  },
  {
    icon: 'ri-global-line',
    title: '韩漫日漫国漫全集',
    desc: '覆盖韩国漫画、日本漫画、国产漫画三大主流类型，恋爱热血悬疑奇幻分类齐全。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    desc: '热门连载漫画每日第一时间同步更新，追更不落后，最新话抢先看。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配畅读',
    desc: '手机、平板、电脑全端适配，无论在哪都能享受最佳漫画阅读体验。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">阅读体验</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            为什么千万漫友选择汗汗漫画？五大核心优势，让在线看漫画更爽快
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="group p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}